<template>
  <div
    class="mission-ranking-title-parts"
    :class="`mission-ranking-title-parts--${rankingType.toLowerCase()}`"
  >
    <p class="mission-ranking-title-parts__title">{{ title }}</p>
    <p class="mission-ranking-title-parts__summary">{{ summary }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { RankingType } from '@/store/stores/pageStore/MissionPage/MissionPageStore'

export default defineComponent({
  name: 'MissionRankingTitleParts',
  props: {
    title: {
      type: String,
      default: '',
    },
    summary: {
      type: String,
      default: '',
    },
    rankingType: {
      type: String as PropType<RankingType>,
      default: 'TOTAL',
    },
  },
})
</script>

<style scoped lang="scss">
.mission-ranking-title-parts {
  position: relative;
  padding: 12px 12px 12px 57px;
  background-color: rgba(#fff, 0.5);
  border-radius: 5px;

  &::before {
    position: absolute;
    top: 0;
    left: 12px;
    width: 36px;
    height: 47px;
    content: '';
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% auto;
  }

  &--total {
    &::before {
      background-image: url('@/assets/img/MissionPage/ranking/img_ranking_title_total.png');
    }
  }

  &--season {
    &::before {
      background-image: url('@/assets/img/MissionPage/ranking/img_ranking_title_season.png');
    }
  }

  &--monthly {
    &::before {
      background-image: url('@/assets/img/MissionPage/ranking/img_ranking_title_monthly.png');
    }
  }

  &__title {
    font-size: 17px;
    font-weight: 500;
    color: $black;
    letter-spacing: 0.04em;
    line-height: 1.41;
  }

  &__summary {
    margin-top: 2px;
    font-size: 11px;
    color: $black70;
    letter-spacing: 0.02em;
    line-height: 1.36;
  }
}
</style>
